import { useState, useCallback } from "react";

/**
 * Custom hook to prevent spam clicking on buttons
 * @param {number} delay - Delay in milliseconds (default: 1000ms)
 * @returns {Object} - { isDisabled, handleClick }
 */
export const useSpamProtection = (delay = 1000) => {
  const [isDisabled, setIsDisabled] = useState(false);

  const handleClick = useCallback(
    (callback) => {
      if (isDisabled) return;

      setIsDisabled(true);

      // Execute the callback
      if (typeof callback === "function") {
        callback();
      }

      // Re-enable after delay
      setTimeout(() => {
        setIsDisabled(false);
      }, delay);
    },
    [isDisabled, delay]
  );

  return { isDisabled, handleClick };
};

export default useSpamProtection;
